import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import ProjectsComponent from '../components/project.component';
import { projects } from '../../../../../../redux/projects/action';
import { selectProjectsQueryItems } from '../../../../../../redux/projects/selector';

const ManagementProject = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params: any = useParams();

  const [columnDefs, setColumnDefs] = useState({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const libraryData = useSelector(selectListItems);
  const queryItems = useSelector(selectProjectsQueryItems);
  const [selectedProject, setSelectedProject] = useState<any>({});

  const fetchQueryById = async () => {
    await dispatch(
      projects.query({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects/query`,
        entity: 'projects',
        jsonData: {
          Records: [{ Id: Number(params?.id) }],
        },
      })
    )
      .then(() => setIsQuery(true))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
   
    if (Number(params?.id) > 0) {
      fetchQueryById();
    } else {
      setIsLoading(false);
    }
  }, []);


  const handleInnerbasicFormChange = (event: any, field: string) => {
    setSelectedProject({ ...selectedProject, [field]: event });
  };

  useEffect(() => {
    if (isQuery) {
      const queryData: any = queryItems?.result?.items;
      if (queryData) setSelectedProject(queryData);
    }
  }, [isQuery, queryItems]);


  const back = () => {
    navigate('/management/service/psa/projects');
  };

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    const ProjectsData = {
      Id: selectedProject?.Id || 0,
      Name: selectedProject?.Name || '',
      Description: selectedProject?.Description || '',
      StartDateTimeInUtc: selectedProject?.StartDateTimeInUtc || new Date().toISOString(),
      EndDateTimeInUtc: selectedProject?.EndDateTimeInUtc || new Date().toISOString(),
      ProjectPriorityId: selectedProject?.ProjectPriorityId || 1,
      ProjectStateId: selectedProject?.ProjectStateId || 1,
    };

    const apiUrl = `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects`;

    if (Number(params?.id) > 0) {

      await dispatch(projects.resetAction({ actionType: 'update' }));
      await dispatch(
        projects.update({
          url: apiUrl,
          entity: 'projects',
          jsonData: { Records: [ProjectsData] },
        })
      );
    } else {

      await dispatch(projects.resetAction({ actionType: 'create' }));
      await dispatch(
        projects.create({
          url: apiUrl,
          entity: 'projects',
          jsonData: { Records: [ProjectsData] },
        })
      );
    }

    back();
  };

  return (
    <>
      {isLoading ? (
        <PageLoader />
      ) : (
        <ProjectsComponent
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedProject={selectedProject}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={params?.id}
          columnDefs={columnDefs}
          libraryData={libraryData}
        />
      )}
    </>
  );
};

export default ManagementProject;
